export enum ContactPhoneStatus {
  ACTIVE = "ACTIVE",
  WRONG_NUMBER = "WRONG_NUMBER",
  DISCONNECTED = "DISCONNECTED",
}
